export const CustomerType = [
  { id: '0', text: 'Thường' },
  { id: '1', text: 'Bạc' },
  { id: '2', text: 'Vàng' },
  { id: '3', text: 'Kim cương' },
];
export const Gender = [
  { id: 'male', text: 'Nam giới' },
  { id: 'female', text: 'Nữ giới' },
  { id: 'other', text: 'Khác' },
];
export const RoleForCustomer = [{ id: 'end_user', text: 'Khách hàng' }];
export const RoleForAgent = [
  { id: 'agent', text: 'Chuyên viên' },
  { id: 'supervisor', text: 'Supervisor' },
  { id: 'administrator', text: 'Administrator' },
  { id: 'team_leader', text: 'Trưởng bộ phận' },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/user/detail_user.const.ts